module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/e43c93409f478be727f730410954c96d.png";